import axios from 'axios'
import * as Redux from 'redux'
import { EducatorActionTypes } from '@EducatorStores/educator.action-types'
import { APIServices } from '@Services/api.service'
import { ClientActionTypes, RegroundTypes } from '../client.action-types'

const getReground = (
    classType: string,
    subClassType?: string,
    queryParams?: any
) => {
    return async function (dispatch: Redux.Dispatch) {
        APIServices.axiosConfig()

        const url = `${APIServices.apiUrlV1}/admin/reground`
        const headers = APIServices.publicHeader()
        const params = {
            limit: 0,
            type: classType,
            ...queryParams,
            // status: 'ACTIVE',
            // parentId: queryParams?.parentId,
            // parentCode: queryParams?.parentCode,
        }
        axios.get(`${url}`, { params, headers }).then((res) => {
            const { data } = res.data
            switch (subClassType) {
                case RegroundTypes.CITY:
                    dispatch({
                        type: ClientActionTypes.GET_CITIES,
                        payload: data,
                    })
                    break
                case RegroundTypes.STATE:
                    dispatch({
                        type: ClientActionTypes.GET_STATES,
                        payload: data,
                    })
                    break
                case RegroundTypes.COUNTRY:
                    dispatch({
                        type: ClientActionTypes.GET_COUNTRIES,
                        payload: data,
                    })
                    break
                case RegroundTypes.ZIP:
                    dispatch({
                        type: ClientActionTypes.GET_ZIPS,
                        payload: data,
                    })
                    break
                case RegroundTypes.ACCESSORY_CITY:
                    dispatch({
                        type: ClientActionTypes.GET_ACCESSORY_CITY,
                        payload: data,
                    })
                    break
                case RegroundTypes.ACCESSORY_STATE:
                    dispatch({
                        type: ClientActionTypes.GET_ACCESSORY_STATE,
                        payload: data,
                    })
                    break
                case RegroundTypes.PART_CITY:
                    dispatch({
                        type: ClientActionTypes.GET_PART_CITY,
                        payload: data,
                    })
                    break
                case RegroundTypes.PART_STATE:
                    dispatch({
                        type: ClientActionTypes.GET_PART_STATE,
                        payload: data,
                    })
                    break
                case EducatorActionTypes.GET_PARENT_STATES:
                    dispatch({
                        type: EducatorActionTypes.GET_PARENT_STATES,
                        payload: data,
                    })
                    break
                case EducatorActionTypes.GET_PARENT_CITIES:
                    dispatch({
                        type: EducatorActionTypes.GET_PARENT_CITIES,
                        payload: data,
                    })
                    break
                case EducatorActionTypes.GET_STUDENT_STATES:
                    dispatch({
                        type: EducatorActionTypes.GET_STUDENT_STATES,
                        payload: data,
                    })
                    break
                case EducatorActionTypes.GET_STUDENT_CITIES:
                    dispatch({
                        type: EducatorActionTypes.GET_STUDENT_CITIES,
                        payload: data,
                    })
                    break
                default:
                    break
            }
        })
    }
}

const RegroundAction = { getReground }

export default RegroundAction
